<template>
  <div class="getCoupon">
    <div class="main">
      <div class="logo">
        <img src="../assets/images/tortoise.png" alt=""/>
        <img src="../assets/images/kuaigui_text.png" alt=""/>
      </div>
      <div class="img">
        <img src="../assets/images/friend_send.png" alt=""/>
        <div class="adviser">找车位，上快龟</div>
      </div>
      <div class="inputs">
        <div class="phone">
          <input type="number" placeholder="输入手机号领取红包" v-model="userPhone" maxlength="11" pattern="[0-9]"  @blur="inputFocusout"/>
        </div>
        <div class="code">
          <input type="number" placeholder="验证码" v-model="phoneCode" pattern="[0-9]" @blur="inputFocusout"/>
          <span @click="getCode" v-if="countDown==null">获取验证码</span>
          <span @click="getCode" v-else>{{countDown>0?countDown:'重新获取'}}</span>
        </div>
      </div>
      <div class="statement">
        <p>点击即同意使用该手机号进行注册</p>
        <span>i</span>
      </div>
      <div class="btn">
        <button type="button" @click="regist">领取红包</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "GetParkCoupon",
    data:function () {
      return {
        userPhone: '',//手机号码
        phoneCode: '',//验证码
        countDown: null,
        isCode: false,
        inviteCode: '',
        isMask: true
      }
    },
    created: function () {

    },
    mounted:function(){
      this.inviteCode = this.$route.query.inviteCode;
      window.console.log(this.inviteCode);
    },
    methods: {
      inputFocusout:function(){
        window.scroll(0,0);//失焦后强制让页面归位
        window.console.log("111");
      },

      //获取手机验证码
      getCode: function () {
        let that = this;
        if(that.countDown||that.countDown>0){
          return false
        }
        if (that.userPhone.length !== 11) {
          this.$toast('请输入正确手机号');
          return false
        }
        //此处获取手机验证码需先提交手机号
        //axios执行POST请求,参数:接口,提交数据。
        //处理函数
        this.$indicator.open('正在发送验证码');
        this.$ajax.post('/user/sendSms', {
          mobile: that.userPhone,
          type: 10
        })
          .then(function (res) {
            window.console.log(res);
            that.$indicator.close();
            that.countDown = 60;
            let si = setInterval(() => {
              that.countDown -= 1;
              if (that.countDown === 0) {
                clearInterval(si);
              }
            }, 1000)
          })
          .catch(function (error) {
            window.console.log(error);
          });
      },

      /*
      * 注册领取红包
      *
      * */
      regist: function () {
        let that = this;
        if (that.userPhone.length !== 11) {
          this.$toast('请输入正确手机号');
          return false
        }
        this.$indicator.open('正在注册');
        window.console.log(that.inviteCode);
        this.$ajax.post('/user/regist', {
          mobile: that.userPhone,
          code: that.phoneCode,
          inviterId: that.inviteCode
        })
          .then(res => {
            this.$indicator.close();
            window.console.log(res);
            // this.$toast('领取成功');
            this.$messagebox({
              title: '领取成功',
              message: '红包可登录快龟共享车位查看',
              confirmButtonText: '我知道了',
              confirmButtonClass: 'confirm_success',
            })
              .then(()=>{
                // this.$router.replace({
                //   path: '/mobile'
                // });
              window.location.href = 'http://prodh5.kuaigui.vip/dist/index.html#/mobile';
            })
          })
          .catch(error => {
            window.console.log(error);
          })
      }
    }
  }
</script>

<style lang="scss" type="text/scss">
  .getCoupon {
    width: 100vw;
    height: 100vh;
    background-image: url("../assets/images/bg_2.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top center;
    /* 超出滚动 */
    overflow: auto;
    .main {
      padding: 5vw;
      .logo {
        display: flex;
        align-items: center;
        img{
          display: block;
          &:first-child {
            width: 8vw;
          }
          &:last-child {
            width: 23.2vw;
            margin-left: 2vw;
          }
        }
      }
      .img{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 10vw 0;
        img{
          width: 79.733333vw;
          margin-bottom: 5vw;
        }
        .adviser {
          width: 35.733333vw;
          height: 6.666667vw;
          line-height: 6.666667vw;
          background: #feebb1;
          border-radius: 3.333333vw;
          text-align: center;
          color: #ff401a;
          font-size: 4vw;
          font-weight: bold;
        }
      }

      .inputs{
        width: 90%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
      }
      .phone{
        width: 100%;
        margin-bottom: 5vw;
        input{
          width: 100%;
          height: 12.4vw;
          border-radius: 6vw;
          background: #fffaec;
          padding-left: 5vw;
        }
      }
      .code{
        width: 100%;
        display: flex;
        margin-bottom: 5vw;
        input{
          width: 80%;
          height: 12.4vw;
          border-radius: 6vw 0 0 6vw;
          background: #fffaec;
          padding-left: 5vw;
        }
        span{
          display: block;
          width: 40%;
          line-height: 12.4vw;
          background: #ffecbb;
          border-radius: 0 6vw 6vw 0;
          color: #ff401a;
          text-align: center;
        }
      }
      .statement{
        /* width: 100%; */
        /* text-align: center; */
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        font-size: 3.2vw;
        margin-bottom: 5vw;
        span{
          display: block;
          width: 3.4vw;
          height: 3.4vw;
          line-height: 3.4vw;
          border-radius: 50%;
          background: #fff;
          text-align: center;
          margin-left: 1vw;
          color: #ff885e;
        }
      }
      .btn{
        width: 90%;
        /*height: 12vw;*/
        margin: 0 auto;
        button{
          width: 100%;
          height: 13.3333333333vw;
          border-radius: 6.6666666667vw;
          border: none;
          outline: none;
          background: linear-gradient(#ffef92,#fede66,#fdcc36);
          color: #ff4319;
          font-size: 4.8vw;
          font-weight: bold;
        }
      }
    }
  }


</style>